import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Prepaidcase } from "./prepaidcase.model";

@Injectable({
  providedIn: 'root'
})

export class PrepaidcaseService {

  constructor(private httpClient: HttpClient) { }

  public selectedPrepaidCase: Prepaidcase;

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDPrepaidcase(prepaidcase: Prepaidcase) {

    prepaidcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    prepaidcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    prepaidcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    prepaidcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = prepaidcase;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/PrepaidCase/IUD', body, { headers: headers });
  }

  FetchPrepaidcaseById(prepaidcase) {

    prepaidcase.Id = + prepaidcase.Id;
    prepaidcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    prepaidcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    prepaidcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    prepaidcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = prepaidcase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/PrepaidCase/Fetch', body, { headers: headers });
  }

  FetchPrepaidCaseList() {

    this.selectedPrepaidCase = new Prepaidcase();
    this.selectedPrepaidCase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedPrepaidCase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedPrepaidCase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedPrepaidCase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedPrepaidCase.ToDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.selectedPrepaidCase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/PrepaidCase/FetchList', body, { headers: headers });
  }

}
